/* global siiimpleToast */
import "./extend/object.js";
import "./extend/dom.js";
import "./extend/string.js";

import { Progress } from "./progress.js";
import { DataManager } from "./data-manager.js";
import { Calendar } from "./modules/cal.js";
import { Settings } from "./modules/settings.js";
import { Subst } from "./modules/subst.js";
import { Timetable } from "./modules/timetable.js";
import { Data } from "./modules/data.js";
import { ClassRegister } from "./modules/classRegister.js";
import { ModalLogin } from "./modals/modalLogin.js";
import { ModalShowInfo } from "./modals/modalShowInfo.js";
import { ModalSpinner } from "./modals/modalSpinner.js";

"use strict";

var _longTouchTimer = null;


export class SinApp {

   constructor() {

      this.setupServiceWorker();
      this.server = window.sinServer;
      this.sections = {}; 
      this.currentTab = null;
      this.settings = {};
      this.lastActionTimestamp;

      inst = this;

      window.progress = new Progress();
      document.querySelector('.overlay-progress').append(progress.getElement());

      window.progress.show = function(show) {
         if (show) document.querySelector('.overlay-progress').removeAttribute('hidden');
         else      document.querySelector('.overlay-progress').setAttribute('hidden', '');
         document.querySelector('.overlay-progress').style.display = show ? 'flex' : 'none';
      }

      let anyAction = () => {
         this.lastActionTimestamp = Date.now();
      };

      document.addEventListener('touchstart', anyAction);
      document.addEventListener('mousedown', anyAction);

      const syncButton = document.querySelector('.menu-item.sync-all');
      syncButton.addEventListener('click', async (event) => {
         if (!this.dm.isReady()) {
            toast.message("Die Datenbank ist noch nicht bereit.");
            return;
         }
         let button = event.currentTarget.querySelector('.animated-button');
         button.classList.add('rotating');
         let time = Date.now();
         this.dm.getSyncData(false, true).then(data => {
            if (data) {
               this.dm.synchronize(data, true).then(() => {
                  document.querySelectorAll('.main-item').removeAttribute('loaded');
                  setTimeout(() => {
                     this.showLastTab();
                  }, 100);
               })
               .catch(e => this.handleError(e));
            }
         })
         .catch(e => {
            console.error(e);
            toast.error(e);
         })
         .finally(() => {
            const rotatingTime = (Date.now()-time) % 1000;
            setTimeout(() => button.classList.remove('rotating'), 1000 - rotatingTime);
         });
      });

      let touchStart = () => {
         _longTouchTimer = setTimeout(async () => {
            const elButton = document.querySelector('.menu-item.sync-all .icon-refresh');
            try {
               document.querySelectorAll('.main-item').removeAttribute('loaded');

               navigator.serviceWorker.ready.then(reg => {
                  reg.active.postMessage({ action: 'GET_VERSION' });
               });

               elButton.classList.add('rotating');
               await this.dm.recreate();
               this.initSections();
               this.showLastTab();
            }
            catch (e) {
               logger.error(e);
               toast.error(e);
            }
            finally {
               elButton.classList.remove('rotating');
            }
         }, 1000);
      };

      let touchEnd = () => {
         if (_longTouchTimer) clearTimeout(_longTouchTimer);
      };

      syncButton.addEventListener('touchstart', touchStart);
      syncButton.addEventListener('mousedown', touchStart);
      syncButton.addEventListener('touchend', touchEnd);
      syncButton.addEventListener('mouseup', touchEnd);

      this.dm = new DataManager(this.server, this);

      window.toast = siiimpleToast.setOptions({
         container: 'body',
         class: 'siiimpleToast',
         position: 'bottom|center',
         margin: 15,
         delay: 0,
         duration: 3000,
         style: {}
      });

      this.sections = {
         'subst-my':       { tab: document.querySelector('.main-item[tab-name="subst-my"]'), obj: false },
         'subst-all':      { tab: document.querySelector('.main-item[tab-name="subst-all"]'), obj: false },
         'tagesplaene':    { tab: document.querySelector('.main-item[tab-name="tagesplaene"]'), obj: false },
         'settings':       { tab: document.querySelector('.main-item[tab-name="settings"]'), obj: false },
         'calendar':       { tab: document.querySelector('.main-item[tab-name="calendar"]'), obj: false },
         'timetable':      { tab: document.querySelector('.main-item[tab-name="timetable"]'), obj: false },
         'class-register': { tab: document.querySelector('.main-item[tab-name="class-register"]'), obj: false },
         'data':           { tab: document.querySelector('.main-item[tab-name="data"]'), obj: false }
      };

      this.statusbar = document.querySelector('.header .statusbar');

      // speichern, ob eine Interneverbindung besteht
      this.connectionChange(navigator.onLine);

      // Funktionen angeben, die ausgeführt werden, wenn sich der Online-Status ändert
      window.addEventListener('online', (event) => this.connectionChange(event.type != "offline"));
      window.addEventListener('offline', (event) => this.connectionChange(event.type != "offline"));

      // Eventhandler für:

      // Schließen der App
      window.addEventListener("beforeunload", () => {
         this.onClose();
      });

      // Klick auf eines der Menü-Tabs öffnet das entsprechende Fenster
      document.querySelectorAll('.menu-item.tab').addEventListener('click', (event) => {

         let button = event.currentTarget.querySelector('.animated-button');
         button.classList.add('active');
         setTimeout(() => button.classList.remove('active'), 200);

         let tabName = event.currentTarget.getAttribute('tab-name');
         this.showTab(tabName);
      });

      // Vertretungsmanager instanzieren
      this.subst     = new Subst(this);
      this.cal       = new Calendar(this);
      this.set       = new Settings(this);
      this.classReg  = new ClassRegister(this);
      this.timetable = new Timetable(this);
      this.data      = new Data(this);

      this.sections['subst-my'].obj = this.subst;
      this.sections['subst-all'].obj = this.subst;
      this.sections['tagesplaene'].obj = this.subst;
      this.sections['settings'].obj = this.set;
      this.sections['calendar'].obj = this.cal;
      this.sections['timetable'].obj = this.timetable;
      this.sections['class-register'].obj = this.classReg;
      this.sections['data'].obj = this.data;

      this.init();
      this.loadHelp();

   }

   loadHelp() {
      this.elHelp = document.createElement('html');
      fetch('help.html')
         .then(response => response.text())
         .then(text => {
            this.elHelp.innerHTML = text;
         });
   }

   showHelp(selector) {
      const elHelpItem = this.elHelp.querySelector(selector)
      if (elHelpItem) {
         new ModalShowInfo("Hilfe", elHelpItem.outerHTML, 'modal-help');
      }
   }

   initSections() {
      Object.values(this.sections).forEach(section => {
         if (section.obj.init) section.obj.init();
      });
   }

   /**
    * Wenn die App gestartet wird, liegt eines der folgenden Szenarien vor:
    * 1. Es liegt eine Benutzerauthentifizierung vor.
    *    a) Die Datenbank muss komplett aktualisiert werden (z.B. nach Update).
    *    b) Die Daten sollen synchronisiert werden.
    * 2. Es liegt keine Benutzerauthentifizierung vor. In diesem Fall wird Benutzername und Kennwort abgefragt
    *    und die Datenbank wird komplett aktualisiert.
    */
   async init() {

      //new ModalSpinner("Lade jetzt die app");

      try {

         // Wenn kein Benutzer angemeldet ist: Anmeldebildschirm zeigen.
         // Bei erfolgreicher Anmeldung wird die App neu geladen.
         if (!this.dm.isLoginVerified()) {
            new ModalLogin(this, true);
         }
         // Wenn ein Benutzer angemeldet ist:
         else {

            await this.dm.init();

            // Wenn die Datenbank leer ist: komplettes Update vom Server ziehen
            if (localStorage.getItem('refreshDatabaseOnInit') === 'true') {
               //console.log('DB full refresh');
               const data = await this.dm.getSyncData(true);
               if (data) {
                  localStorage.setItem('lastSync', 0);
                  await this.dm.dropDatabase();
                  await this.dm.init();
                  await this.dm.synchronize(data);
                  localStorage.setItem('refreshDatabaseOnInit', false);
               }
            }

            // Bei jedem Laden:
            await this.dm.createCache();
            this.selectTheme();
            this.selectFontSize();
            this.initSections();
            this.showLastTab();
         }

      }
      catch(e) {
         toast.alert(e, { duration: 8000 });
         logger.error(e);
      }

      this.lastActionTimestamp = Date.now();

      setInterval(async () => {
         if (localStorage.getItem('timeout') === 'true' && this.dm.isLoginVerified() && Date.now() - this.lastActionTimestamp > 1 * 60 * 1000) {
            this.timeout();
            return;
         }
         if (this.currentSection && this.currentSection.refresh) this.currentSection.refresh();
      }, 1000);

   }

   showTab(tabName) {
      this.currentTab = this.sections[tabName].tab;
      this.currentSection = this.sections[tabName].obj;

      // Tabnamen als aktuelles Tab speichern
      localStorage.setItem('sinappCurrentTab', tabName);

      // Im Menu nur aktuelles Tab markieren
      document.querySelectorAll('.menu-item').forEach(item => item.classList.remove('selected'));
      document.querySelector('.menu-item[tab-name="'+tabName+'"]').classList.add('selected');

      // Wenn das Tab noch nicht geladen wurde: Inhalt laden
      let loadData = this.currentTab.getAttribute('loaded') == undefined;

      if      (tabName == 'settings')       this.set.load(loadData);
      else if (tabName == 'subst-my')       this.subst.loadMy(loadData);
      else if (tabName == 'subst-all')      this.subst.loadAll(loadData);
      else if (tabName == 'tagesplaene')    this.subst.loadTagesplaene(loadData);
      else if (tabName == 'calendar')       this.cal.load(loadData);
      else if (tabName == 'timetable')      this.timetable.load(loadData);
      else if (tabName == 'class-register') this.classReg.load(loadData);
      else if (tabName == 'data')           this.data.load(loadData);

      // Statusleiste aktualisieren

      // alle Tabs schließen, nur das aktuelle anzeigen
      //this.tabs[tabName].style.height = '100%';
      for (let i in this.sections) this.sections[i].tab.classList.add('hidden');
      //this.tabs[tabName].classList.remove('hidden');
      this.currentTab.classList.remove('hidden');

   }


    // Ruft das zuletzt geladene Tab auf
   showLastTab() {
      let tabName = localStorage.getItem('sinappCurrentTab') || 'subst-my';
      this.showTab(tabName);
   }

   // Wird ausfegührt, wenn die Anwendung geschlossen wird
   onClose() {

   }

   // Wird ausgeführt, wenn das Gerät online oder offline geht
   connectionChange(online) {
      this.dm.online = online;
      document.querySelector('.sync-all').setStyles({opacity: online == true ? "1" : ".2"});
   }

   selectTheme() {

      const head = document.getElementsByTagName('HEAD')[0];

      head.querySelectorAll('.theme').forEach(theme => {
         theme.remove();
      });

      this.dm.getCurrentTheme().then(theme => {
         if (!theme) return;
         let elStyle = document.createElement('style');
         elStyle.classList.add('theme');
         elStyle.innerHTML = theme.data;
         head.appendChild(elStyle);
      });

   }

   selectFontSize() {
      document.querySelector('html').style.fontSize = this.dm.getFontSize();
   }

   async loadCalendar() {

   }

   async updateDatabase() {
      await this.dm.recreate();
   }


   showLoading(show) {
      document.querySelector('.overlay-loading').hidden = show == false ? true : false;
   }

   toast(message) {
      let node = document.querySelector('.toast');
      node.innerHTML = message;
      node.hidden = false;

      setTimeout(function () {
         node.hidden = true;
      }, 3000);

   }

   timeout() {
      //console.log('timeout');
      this.dm.sinRequest({ action: 'usr-delete-auth-token', 'client-id': localStorage.getItem('clientId') });
      localStorage.removeItem('authToken');
      new ModalLogin(this, false)
   }

   showUpdateBar() {
      document.querySelector('.update-message').setStyles({height: 'unset', overflow: 'unset' });
   }

   setupServiceWorker() {
   
      let newWorker;
   
      /*
      document.querySelector('#app-update').onclick = () => {
         newWorker.postMessage({ action: 'SERVICE_WORKER_ACTIVATE' });
      };
      
      document.querySelector('#app-update-cancel').onclick =  (event) => {
         document.querySelector('.update-message').style.height = '0';
      };
      */
   
      if ('serviceWorker' in navigator) {

         navigator.serviceWorker.register('sw.js').then(reg => {
            this.serviceWorkerRegistration = reg;
            reg.addEventListener('updatefound', () => {
               newWorker = reg.installing;
               newWorker.addEventListener('statechange', () => {
                  switch (newWorker.state) {
                     case 'installed':
                        if (navigator.serviceWorker.controller) {
                           newWorker.postMessage({ action: 'SERVICE_WORKER_ACTIVATE' });
                        }
                     break;
                  }
               });
            });
         });
   
         let refreshing;
         navigator.serviceWorker.addEventListener('controllerchange', () => {
            if (refreshing) return;
            //console.log('controllerchange');
            localStorage.setItem('refreshDatabaseOnInit', true);
            window.location.reload(true);
            newWorker.postMessage({ action: 'GET_VERSION' });
            refreshing = true;
         });
   
         navigator.serviceWorker.onmessage = (event) => {
           if (event.data && event.data.action === 'SHOW_NOTIFICATION') {
              showNotification(event.data.title, event.data.body)
           }
           if (event.data.type === 'GET_VERSION') {
               toast.message(`Version ${event.data.data} installiert`);
               localStorage.setItem('appVersion', event.data.data);
            }

         };
   
         // Wenn noch keine Version gespeichert wurde: Version speichern.
         if (!localStorage.getItem('appVersion')) {
            navigator.serviceWorker.ready.then(reg => {
               reg.active.postMessage({ action: 'GET_VERSION' });
            });
         }
    
      }
      else {
         logger.error('serviceWorker not available')
      }
         
   }

   handleError(e) {
      logger.error(e);
      toast.alert(e, { duration: 8000 });
   }


};
